import React, { useEffect, useState } from 'react';

const ZohoChat = () => {
  const [shouldLoadScript, setShouldLoadScript] = useState(false);

  const checkURLCondition = () => {
    const currentURL = window.location.href;
    return currentURL.includes('/dashboard/') && currentURL.split('/dashboard/')[1].startsWith('guide-portal');
  };

  useEffect(() => {

    setShouldLoadScript(checkURLCondition());

    const handleURLChange = () => {
      setShouldLoadScript(checkURLCondition());
    };
    window.addEventListener('popstate', handleURLChange);
    window.addEventListener('pushstate', handleURLChange);
    window.addEventListener('replacestate', handleURLChange);

    return () => {
      window.removeEventListener('popstate', handleURLChange);
      window.removeEventListener('pushstate', handleURLChange);
      window.removeEventListener('replacestate', handleURLChange);
    };
  }, []);

  useEffect(() => {
    if (shouldLoadScript) {

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'zsiqchat';
      script.defer = true;
      script.innerHTML = `
        var $zoho=$zoho || {};
        $zoho.salesiq = $zoho.salesiq || {
          widgetcode: "siqb842cdcb70669f24b2603958c4d8195f3cb76863ce02ee051a83e641d4623709cdaa20605399e6aebe851f7481452156",
          values:{},
          ready:function(){}
        };
        var d=document;
        var s=d.createElement("script");
        s.type="text/javascript";
        s.id="zsiqscript";
        s.defer=true;
        s.src="https://salesiq.zohopublic.eu/widget";
        var t=d.getElementsByTagName("script")[0];
        t.parentNode.insertBefore(s,t);
      `;
      document.body.appendChild(script);
    } else {

      if (document.getElementById('zsiqchat')) {
        document.getElementById('zsiqchat').remove();
      }
      if (document.getElementById('zsiqscript')) {
        document.getElementById('zsiqscript').remove();
      }
    }
  }, [shouldLoadScript]);


  return null;
};

export default ZohoChat;
